export default "__VITE_ASSET__CKFlHsYz__"